export const LabelHelper = () => {
  const formatDate = () => {
    const abbreviated = (label: string) => {
      const isntAbbreviated = label.length > 3
      if (isntAbbreviated) {
        return label.slice(0, 3)
      }
      return label
    }

    const joinYear = (label: string) => {
      const year = new Date().getFullYear()
      return `${label} ${year}`
    }

    return {
      abbreviated,
      joinYear,
    }
  }

  const formatCurrency = () => {
    const abbreviated = (value: number) => {
      const valueInteger = String(value).split('.')[0]
      const isntThousand = valueInteger.length < 4
      const isntMillion = valueInteger.length < 7

      if (isntThousand) {
        return `R$ ${value}`
      }
      if (isntMillion) {
        return `R$ ${Number(valueInteger) / 1000}K`
      }
      return `R$ ${Number(valueInteger) / 1000000}M`
    }

    return {
      abbreviated,
    }
  }

  return {
    formatCurrency,
    formatDate,
  }
}
